import { Body, RecommendationNames } from './postPage.reducer';
import { AppState, PostPageAppState } from '../../initialStateRegistration';

const createBlockNames = (body: Body) => body.map(block => block.type);

const getPostPage = (state: AppState) => (state as PostPageAppState).template;

export const getTitle = (state: AppState) => getPostPage(state).title;

export const getBy = (state: AppState) => getPostPage(state).by;

export const getAuthors = (state: AppState) => getPostPage(state).authors;

export const getOwner = (state: AppState) => getPostPage(state).owner;

export const getUpdatedAtFormatted = (state: AppState) => getPostPage(state).updatedAtFormatted;

export const getCover = (state: AppState) => getPostPage(state).cover;

export const getImageCover = (state: AppState) => getCover(state).image;

export const getBody = (state: AppState) => getPostPage(state).body;

export const getShareConfig = (state: AppState) => getPostPage(state).shareConfig;

export const getArticleId = (state: AppState) => getPostPage(state).articleId;

export const getBlockNames = (state: AppState) => createBlockNames(getBody(state));

export const getChannels = (state: AppState) => getPostPage(state).channels;

export const getCreatedAt = (state: AppState) => getPostPage(state).createdAt;

export const getUpdatedAt = (state: AppState) => getPostPage(state).updatedAt;

export const getTags = (state: AppState) => getPostPage(state).tags;

export const getRecommendationsByKey = (key: RecommendationNames) => (state: AppState) => getPostPage(state)[key];

export const getRecommendationsNextByKey = (key: RecommendationNames) => (state: AppState) => getRecommendationsByKey(key)(state).next;

export const getSponsor = (state: AppState) => getPostPage(state).sponsor;

export const getCommercialTags = (state: AppState) => getPostPage(state).commercialTags;

export const getDfpCategory = (state: AppState) => getPostPage(state).dfpCategory;

export const getNoIndex = (state: AppState) => getPostPage(state).noIndex;

export const getNumberOfWordsTyped = (state: AppState) => getPostPage(state).numberOfWordsTyped;

export const getContentTypesToQuantity = (state: AppState) => getPostPage(state).contentTypesToQuantity;
